declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export type TrackParams = Record<string, string | number | undefined>;

export function trackEvent(eventName: string, params?: TrackParams) {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;
  gtag("event", eventName, params);
}